<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>The Man In The Mirror: Solving The 24 Problems Men Face</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="tx"><br/><br/><br/><br/><br/></p>
<p class="ct" id="p0025-01-0"><a id="page25"></a><a href="#/contents#tocp_1" id="conp_1">PART 1</a> </p>
<p class="ct1"><a href="#/contents#tocp_1">SOLVING OUR IDENTITY PROBLEMS</a> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter6.vue?77ee265a